import auth from "./auth";
import common from "./common";
import domain from "./domain";
import errors from "./errors";
import nav from "./nav";

/**
 * ja が型の基準（主言語）。en は同じキー集合を維持する
 * （src/lang/parity.test.ts が担保）。
 */
export const ja = { common, nav, auth, errors, domain } as const;
